import { externalApi } from '~/utils/api/external';

export type UploadBundleProgressEvent = Parameters<
  NonNullable<NonNullable<Parameters<typeof externalApi.post>[2]>['onDownloadProgress']>
>[0];

// eslint-disable-next-line @typescript-eslint/ban-types
export const uploadBundle = async (
  uploadUrl: string,
  form: object,
  config: {
    onUploadProgress: (progressEvent: UploadBundleProgressEvent) => void;
  },
) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  externalApi.post<any>(uploadUrl, form, {
    onUploadProgress: config.onUploadProgress,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
